if (!customElements.get('product-description')) {
  customElements.define(
    'product-description',
    class ProductDescription extends HTMLElement {
      constructor() {
        super();
        this.sectionId = null;
        this.unsubscribe = null;
        this.activeRequest = null;
        this.onVariantChange = this.onVariantChange.bind(this);
      }

      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.cacheDebugElement();
        this.unsubscribe = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.onVariantChange,
        );
      }

      disconnectedCallback() {
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
        this.abortActiveRequest();
      }

      onVariantChange({data}) {
        console.log('Variant changed', data);

        if (data?.variant) this.updateDebug(data.variant);

        if (data?.html) this.replaceFromHTML(data.html);
        else if (data?.url) this.fetchAndReplace(data.url);
      }

      fetchAndReplace(baseUrl) {
        if (!this.sectionId) return;

        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);

        this.abortActiveRequest();
        const controller = new AbortController();
        this.activeRequest = controller;

        fetch(url.toString(), {signal: controller.signal})
          .then((r) => r.text())
          .then((html) => this.replaceFromHTML(html))
          .catch(() => {})
          .finally(() => {
            if (this.activeRequest === controller) this.activeRequest = null;
          });
      }

      replaceFromHTML(html) {
        // Shopify bazen string bazen Document döndürür
        const doc =
          html instanceof Document
            ? html
            : new DOMParser().parseFromString(html, 'text/html');

        const freshEl = doc.querySelector(
          `product-description[data-section='${this.sectionId}']`,
        );
        if (!freshEl) return;

        const newInner = freshEl.innerHTML;

        this.innerHTML = newInner;

        this.cacheDebugElement();
      }

      restoreInputValues() {
        Object.entries(this.inputsState).forEach(([id, value]) => {
          const el = this.querySelector(`#${id}`);
          if (el) el.value = value;
        });
      }

      cacheDebugElement() {
        this.debugEl = this.querySelector('[data-custom-product-description]');
      }

      updateDebug(variant) {
        if (this.debugEl)
          this.debugEl.textContent = JSON.stringify(variant, null, 2);
      }

      abortActiveRequest() {
        if (this.activeRequest) {
          this.activeRequest.abort();
          this.activeRequest = null;
        }
      }
    },
  );
}
